import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { config } from '../config';


@Injectable({
  providedIn: 'root'
})
export class GroupService {

  constructor(private _http: HttpClient) { }
  getGroups(params: { groupId: string | number; isTeamLead: boolean | string }) {
    const httpParams = new HttpParams()
      .set('groupId', params.groupId.toString())
      .set('isTeamLead', params.isTeamLead.toString());
    
    return this._http.get(`${config.baseUrl}/group`, { params: httpParams });
  }

}
